/**
 * @generated SignedSource<<a09130d5306955336623c9044235b868>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleActionWidgetArticle$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleCommentsTriggerArticle" | "articleReactionArticle">;
  readonly " $fragmentType": "articleActionWidgetArticle";
};
export type articleActionWidgetArticle$key = {
  readonly " $data"?: articleActionWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleActionWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleActionWidgetArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleCommentsTriggerArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleReactionArticle"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "e61d1a4c876c7528171a76ef6153ee50";

export default node;
